import { FieldDef, GroupDef, GuiDef, ValidatorDef, TabDefinition, CollapsableDef } from '@/objects/gui';
import { ParticipantID } from '@/objects/generated';
import { markRaw, computed } from 'vue';
import { InputInt, ValidatedInt, InputText, ValidatedText } from '@/components';
import type { SelectLine, SelectLineValueType } from '@/objects/SelectLine';

export class ParticipantIDGuiDef extends GuiDef<ParticipantID> {
    constructor() {
        super('ParticipantID');

        const ParticipantIDTypeID = new FieldDef<ParticipantID>();
        ParticipantIDTypeID.Name = 'ParticipantIDTypeID';
        ParticipantIDTypeID.FieldName = 'ParticipantIDTypeID';
        ParticipantIDTypeID.DefinedFor = 'Both';
        ParticipantIDTypeID.TranslationKey = 'participantid.participantidtypeid';
        ParticipantIDTypeID.Editable = true;
        ParticipantIDTypeID.Filterable = false;
        ParticipantIDTypeID.Sortable = true;
        ParticipantIDTypeID.CssClasses = '';
        ParticipantIDTypeID.value = (participantid) => participantid.ParticipantIDTypeID;
        ParticipantIDTypeID.setValue = (participantid, value) => {
            if (value === null || value === undefined || value === '' || isNaN(value)) {
                value = 0;
            }
            participantid.ParticipantIDTypeID = value;
        };
        ParticipantIDTypeID.DetailEditor = markRaw(InputInt);
        ParticipantIDTypeID.DetailEditorProps = {};
        ParticipantIDTypeID.CellEditor = markRaw(InputInt);
        ParticipantIDTypeID.CellEditorProps = {};
        ParticipantIDTypeID.CellRenderer = markRaw(ValidatedInt);
        ParticipantIDTypeID.CellRendererProps = {};
        ParticipantIDTypeID.Validator = null;
        ParticipantIDTypeID.SortDirection = undefined;
        ParticipantIDTypeID.cellClassRules = undefined;
        ParticipantIDTypeID.MinWidth = undefined;
        ParticipantIDTypeID.MaxWidth = undefined;
        ParticipantIDTypeID.Tooltip = null;
        this.Fields.push(ParticipantIDTypeID);

        const Value = new FieldDef<ParticipantID>();
        Value.Name = 'Value';
        Value.FieldName = 'Value';
        Value.DefinedFor = 'Both';
        Value.TranslationKey = 'participantid.value';
        Value.Editable = true;
        Value.Filterable = true;
        Value.Sortable = true;
        Value.CssClasses = '';
        Value.value = (participantid) => participantid.Value;
        Value.setValue = (participantid, value) => (participantid.Value = value);
        Value.DetailEditor = markRaw(InputText);
        Value.DetailEditorProps = {};
        Value.CellEditor = markRaw(InputText);
        Value.CellEditorProps = {};
        Value.CellRenderer = markRaw(ValidatedText);
        Value.CellRendererProps = {};
        Value.Validator = null;
        Value.SortDirection = undefined;
        Value.cellClassRules = undefined;
        Value.MinWidth = undefined;
        Value.MaxWidth = undefined;
        Value.Tooltip = null;
        this.Fields.push(Value);
    }

    public async LoadDependencies() {}
}
